var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("timeline-item-card", {
    scopedSlots: _vm._u([
      {
        key: "body",
        fn: function () {
          return [
            _c(
              "b-row",
              { staticClass: "align-items-center" },
              [
                _c(
                  "b-col",
                  [
                    _c("i18n", {
                      staticClass: "mb-0",
                      attrs: {
                        path: "client-profile.changelog.duplicate",
                        tag: "p",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "name",
                          fn: function () {
                            return [
                              _c("span", [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(
                                      _vm.getChangelogName(_vm.userDetails)
                                    ) +
                                    "\n            "
                                ),
                              ]),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "clientProfile",
                          fn: function () {
                            return [
                              _c("client-profile-name-label", {
                                attrs: { "client-profile": _vm.value.from },
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "footer",
        fn: function () {
          return [
            _c(
              "b-row",
              {
                staticClass: "justify-content-between align-items-center",
                attrs: { "no-gutters": "" },
              },
              [
                _c("p", { staticClass: "tiny-f mb-0" }, [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm._f("formatDateHour")(_vm.insertionTimestamp)) +
                      "\n      "
                  ),
                ]),
              ]
            ),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }